import { GOOGLE_RECAPTCHA_SITE_KEY } from '@reverbdotcom/env';
import window from './window_wrapper';
import { elog } from './elog';

export async function generateRecaptchaToken(action) {
  const recaptcha = window.grecaptcha?.enterprise;

  if (!recaptcha) {
    logEvent(
      'failure',
      {
        expected_action: action,
        token_present: false,
      },
    );

    return null;
  }

  const token = await recaptcha.execute(GOOGLE_RECAPTCHA_SITE_KEY, { action });

  logEvent(
    'success',
    {
      expected_action: action,
      token_present: !!token,
    },
  );

  return token;
}

function logEvent(eventName: 'success' | 'failure', data: Record<string, any>) {
  elog.info(`generate_recaptcha_token.${eventName}`, data);
}
